import { type LogoProps } from '../registry';

export function CaseysIndoorGolfClubLogo({
  width = 140,
  height = 104,
  className = 'h-auto max-w-full',
  ariaHidden = true,
  viewBox,
}: LogoProps) {
  return (
    <svg
      id="caseysindoorgolfclub-logo-layer"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox ?? '0 0 140 104'}
      width={width}
      height={height}
      className={className}
      aria-hidden={ariaHidden}
    >
      <path
        fill="#0A2E0B"
        stroke="#EFEAD1"
        strokeWidth={0.238}
        d="M.791 49.934h24.39v25.814H.632l6.335-13.462zM139.526 49.934h-24.389v25.814h24.389l-6.493-13.462z"
      />
      <path
        fill="url(#caseysindoorgolfclub_svg__a)"
        stroke="#AA7935"
        strokeWidth={0.158}
        d="M2.691 51.518h21.222v22.647H2.691l5.86-11.878z"
      />
      <path
        fill="url(#caseysindoorgolfclub_svg__b)"
        stroke="#AA7935"
        strokeWidth={0.158}
        d="M137.624 51.518h-21.222v22.647h21.222l-6.176-11.878z"
      />
      <mask
        id="caseysindoorgolfclub_svg__c"
        width={136}
        height={24}
        x={2}
        y={51}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M2.691 51.514h21.222V74.16H2.691l5.86-11.878zm134.933 0h-21.222V74.16h21.222l-6.177-11.878z"
        />
      </mask>
      <g
        stroke="#3F2506"
        strokeOpacity={0.23}
        strokeWidth={0.214}
        mask="url(#caseysindoorgolfclub_svg__c)"
      >
        <path d="M.951 53.099c7.285-.317 15.045.792 24.864.317M114.344 53.258c7.918-.634 17.421.475 25.339-.158M.951 55.16c7.285-.317 15.045.791 24.864.316M114.344 55.317c7.918-.634 17.421.475 25.339-.159M.951 57.218c7.285-.317 15.045.792 24.864.317M114.344 57.375c7.918-.633 17.421.475 25.339-.158M.951 59.277c7.285-.317 15.045.791 24.864.316M114.344 59.434c7.918-.634 17.421.475 25.339-.159M.951 61.335c7.285-.316 15.045.792 24.864.317M114.344 61.494c7.918-.633 17.421.475 25.339-.158M.951 63.394c7.285-.317 15.045.792 24.864.317M114.344 63.553c7.918-.634 17.421.475 25.339-.158M.951 65.452c7.285-.316 15.045.792 24.864.317M114.344 65.611c7.918-.633 17.421.476 25.339-.158M.951 67.511c7.285-.317 15.045.792 24.864.317M114.344 67.67c7.918-.633 17.421.475 25.339-.158M.951 69.57c7.285-.317 15.045.792 24.864.316M114.344 69.729c7.918-.634 17.421.475 25.339-.159M.951 71.628c7.285-.317 15.045.792 24.864.317M114.344 71.787c7.918-.633 17.421.475 25.339-.158M.951 73.689c7.285-.317 15.045.792 24.864.317M114.344 73.846c7.918-.634 17.421.475 25.339-.159" />
      </g>
      <path
        fill="#0A2E0B"
        d="m16.629 72.899 8.077-2.217 1.9 5.067zm107.059 0-7.919-2.217-1.9 5.067z"
      />
      <path
        fill="#56330A"
        d="m18.055 74.008 5.068-1.584.791 1.9zm104.208 0-4.91-1.584-.792 1.9z"
      />
      <path
        fill="#0A2E0B"
        stroke="#EFEAD1"
        strokeWidth={0.238}
        d="M70.19 103.099c28.383 0 51.392-23.008 51.392-51.391S98.572.316 70.19.316 18.8 23.326 18.8 51.708s23.008 51.391 51.391 51.391Z"
      />
      <path
        fill="url(#caseysindoorgolfclub_svg__d)"
        stroke="#EFEAD1"
        strokeWidth={0.222}
        d="M70.19 101.468c27.482 0 49.76-22.279 49.76-49.76 0-27.482-22.278-49.76-49.76-49.76s-49.76 22.278-49.76 49.76 22.278 49.76 49.76 49.76Z"
      />
      <mask
        id="caseysindoorgolfclub_svg__e"
        width={100}
        height={101}
        x={20}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M70.19 101.464c27.482 0 49.76-22.279 49.76-49.76 0-27.482-22.278-49.76-49.76-49.76s-49.76 22.278-49.76 49.76 22.278 49.76 49.76 49.76"
        />
      </mask>
      <g mask="url(#caseysindoorgolfclub_svg__e)">
        <path
          fill="url(#caseysindoorgolfclub_svg__f)"
          d="M63.239 2.997c1.922-.274 3.462-.62 3.44-.77-.022-.152-1.597-.052-3.518.222-1.922.274-3.462.619-3.44.77.021.151 1.597.052 3.518-.222"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__g)"
          d="M68.694 3.864c1.94-.06 3.503-.432 3.49-.828-.012-.397-1.595-.67-3.535-.609s-3.502.432-3.49.828c.013.397 1.595.67 3.535.609"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__h)"
          d="M73.688 2.62c1.936.138 3.514.128 3.524-.022s-1.55-.384-3.486-.522-3.514-.128-3.525.022c-.01.15 1.55.384 3.487.522"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__i)"
          d="M54.008 6.014c1.83-.648 3.23-1.405 3.13-1.692-.102-.286-1.667.007-3.497.655s-3.23 1.406-3.13 1.692c.102.286 1.668-.007 3.497-.655"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__j)"
          d="M60.98 5.2c1.904-.377 3.376-1.047 3.287-1.495-.09-.449-1.705-.507-3.609-.13s-3.375 1.046-3.286 1.495 1.704.507 3.608.13"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__k)"
          d="M66.8 7.346c1.935-.148 3.458-.87 3.4-1.612-.056-.742-1.67-1.224-3.606-1.076s-3.458.87-3.401 1.612c.056.742 1.671 1.224 3.606 1.076"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__l)"
          d="M73.938 5.96c1.935.16 3.544-.214 3.595-.833.05-.62-1.477-1.25-3.411-1.408-1.935-.159-3.544.215-3.595.834-.05.619 1.477 1.25 3.411 1.408"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__m)"
          d="M79.327 4.674c1.905.37 3.51.36 3.584-.024.075-.383-1.41-.994-3.315-1.365-1.905-.37-3.51-.359-3.584.025-.075.383 1.41.994 3.315 1.364"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__n)"
          d="M46.614 9.814c1.692-.952 2.917-1.983 2.736-2.304s-1.697.192-3.389 1.143-2.916 1.984-2.736 2.304 1.698-.191 3.39-1.143"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__o)"
          d="M51.95 9.413c1.781-.768 3.032-1.842 2.792-2.399s-1.88-.383-3.661.385c-1.783.769-3.033 1.843-2.793 2.4.24.555 1.879.383 3.661-.386"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__p)"
          d="M59.067 8.56c1.88-.485 3.254-1.458 3.07-2.173s-1.858-.903-3.738-.418c-1.88.484-3.253 1.457-3.069 2.172s1.858.903 3.737.419"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__q)"
          d="M72.28 10.6c1.938.098 3.55-.61 3.6-1.584.049-.973-1.483-1.842-3.42-1.941-1.94-.099-3.55.61-3.6 1.584-.05.973 1.481 1.842 3.42 1.94"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__r)"
          d="M78.935 9.222c1.9.39 3.577.05 3.745-.762.167-.812-1.239-1.788-3.14-2.18-1.901-.39-3.578-.05-3.745.763-.167.812 1.239 1.787 3.14 2.179"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__s)"
          d="M84.375 7.933c1.847.598 3.496.613 3.684.033S86.903 6.43 85.056 5.83c-1.846-.598-3.495-.613-3.684-.032-.188.58 1.157 1.535 3.003 2.134"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__t)"
          d="M88.095 6.877c1.802.72 3.365 1.05 3.49.738.124-.313-1.235-1.15-3.038-1.87s-3.365-1.05-3.49-.737c-.125.312 1.235 1.15 3.038 1.87"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__u)"
          d="M40.203 14.597c1.51-1.22 2.52-2.473 2.258-2.798-.263-.326-1.7.4-3.21 1.62-1.51 1.219-2.52 2.472-2.257 2.797s1.7-.4 3.21-1.62"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__v)"
          d="M44.599 14.36c1.6-1.096 2.588-2.44 2.204-3-.383-.559-1.992-.123-3.593.974-1.602 1.097-2.589 2.44-2.205 3s1.992.124 3.594-.973"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__w)"
          d="M50.562 13.82c1.724-.893 2.793-2.25 2.39-3.03-.405-.78-2.13-.688-3.853.205s-2.793 2.249-2.389 3.029 2.129.688 3.852-.204"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__x)"
          d="M57.546 12.997c1.845-.603 3.089-1.862 2.778-2.813-.31-.95-2.058-1.233-3.903-.63-1.845.602-3.09 1.861-2.779 2.812s2.058 1.234 3.903.63"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__y)"
          d="M64.97 11.904c1.924-.253 3.375-1.288 3.24-2.312-.134-1.025-1.803-1.65-3.727-1.399-1.925.253-3.376 1.288-3.242 2.313.135 1.024 1.804 1.65 3.728 1.398"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__z)"
          d="M70.53 16.235c1.94.019 3.523-.988 3.535-2.248s-1.551-2.296-3.492-2.315c-1.941-.018-3.524.988-3.536 2.248s1.551 2.297 3.492 2.315"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__A)"
          d="M77.575 14.846c1.903.38 3.63-.236 3.86-1.378.228-1.142-1.129-2.377-3.032-2.758s-3.631.235-3.86 1.377c-.229 1.143 1.128 2.377 3.031 2.759"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__B)"
          d="M84.016 13.43c1.826.66 3.581.43 3.922-.512.34-.942-.864-2.24-2.69-2.9-1.825-.66-3.58-.43-3.92.512-.341.943.863 2.241 2.688 2.9"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__C)"
          d="M89.481 12.128c1.745.85 3.437.97 3.779.27.342-.703-.796-1.961-2.54-2.811-1.745-.85-3.437-.971-3.779-.27-.342.702.795 1.96 2.54 2.811"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__D)"
          d="M93.607 11.037c1.682.969 3.254 1.393 3.51.947.257-.446-.899-1.592-2.581-2.56-1.682-.969-3.254-1.393-3.51-.947-.257.445.899 1.592 2.58 2.56"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__E)"
          d="M96.108 10.208c1.646 1.028 3.074 1.712 3.19 1.527.115-.184-1.126-1.168-2.772-2.196-1.647-1.028-3.075-1.712-3.19-1.527s1.126 1.168 2.772 2.196"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__F)"
          d="M34.057 20.29c1.274-1.464 2.065-2.862 1.767-3.12-.298-.26-1.572.717-2.846 2.182s-2.065 2.862-1.766 3.121c.298.26 1.572-.718 2.845-2.182"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__G)"
          d="M37.68 20.151c1.352-1.392 2.055-2.903 1.57-3.374-.485-.47-1.974.277-3.326 1.67s-2.054 2.903-1.57 3.374c.485.47 1.974-.277 3.326-1.67"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__H)"
          d="M42.77 19.787c1.472-1.265 2.181-2.854 1.584-3.55-.598-.696-2.276-.235-3.749 1.03-1.472 1.264-2.181 2.854-1.583 3.55s2.276.234 3.748-1.03"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__I)"
          d="M48.987 19.221c1.625-1.06 2.453-2.671 1.849-3.597-.605-.926-2.412-.817-4.038.244-1.625 1.061-2.453 2.672-1.848 3.597.604.926 2.411.817 4.037-.244"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__J)"
          d="M55.93 18.455c1.784-.765 2.837-2.301 2.353-3.431-.485-1.13-2.324-1.426-4.108-.661s-2.837 2.301-2.352 3.431c.484 1.13 2.323 1.426 4.107.661"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__K)"
          d="M63.22 17.463c1.901-.387 3.236-1.72 2.98-2.975-.255-1.257-2.005-1.961-3.907-1.574s-3.236 1.72-2.98 2.976c.255 1.256 2.005 1.96 3.906 1.573"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__L)"
          d="M75.86 21.39c1.907.357 3.667-.497 3.931-1.907s-1.07-2.841-2.977-3.198c-1.908-.357-3.668.497-3.932 1.906-.264 1.41 1.07 2.842 2.977 3.2"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__M)"
          d="M82.754 19.891c1.806.713 3.66.302 4.141-.918.482-1.22-.59-2.787-2.396-3.5-1.805-.713-3.66-.302-4.141.918-.482 1.22.591 2.787 2.396 3.5"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__N)"
          d="M89.102 18.437c1.687.96 3.509.94 4.068-.045.56-.984-.355-2.56-2.042-3.519-1.688-.959-3.51-.938-4.069.046s.356 2.56 2.043 3.518"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__O)"
          d="M94.574 17.134c1.586 1.119 3.294 1.428 3.814.69.52-.737-.344-2.242-1.93-3.36-1.586-1.12-3.294-1.428-3.814-.69-.52.737.344 2.242 1.93 3.36"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__P)"
          d="M98.876 16.048c1.512 1.217 3.06 1.802 3.458 1.309.397-.494-.507-1.881-2.019-3.098s-3.06-1.802-3.458-1.308c-.397.494.507 1.88 2.019 3.097"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__Q)"
          d="M101.774 15.206c1.468 1.27 2.837 2.093 3.058 1.838.22-.256-.791-1.492-2.258-2.762s-2.837-2.093-3.058-1.838.79 1.492 2.258 2.762"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__R)"
          d="M28.52 26.746c.997-1.665 1.606-3.134 1.36-3.281-.245-.147-1.252 1.084-2.25 2.749-.997 1.665-1.607 3.134-1.361 3.28.245.148 1.253-1.083 2.25-2.748"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__S)"
          d="M31.282 26.688c1.05-1.633 1.5-3.213 1.008-3.53-.493-.317-1.744.75-2.793 2.382s-1.502 3.213-1.009 3.53 1.744-.75 2.794-2.382"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__T)"
          d="M35.488 26.424c1.143-1.569 1.506-3.251.81-3.758-.695-.506-2.185.355-3.328 1.923s-1.506 3.251-.81 3.758c.695.507 2.185-.354 3.328-1.923"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__U)"
          d="M40.917 25.993c1.281-1.458 1.651-3.227.827-3.951s-2.53-.129-3.811 1.33c-1.281 1.458-1.652 3.227-.828 3.95.825.725 2.531.13 3.812-1.329"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__V)"
          d="M47.28 25.435c1.464-1.275 1.965-3.095 1.12-4.064s-2.716-.72-4.179.556c-1.463 1.275-1.964 3.095-1.119 4.064s2.716.72 4.179-.556"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__W)"
          d="M54.236 24.754c1.67-.989 2.439-2.78 1.716-4-.722-1.22-2.662-1.408-4.332-.42-1.67.99-2.439 2.78-1.716 4 .722 1.221 2.661 1.409 4.332.42"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__X)"
          d="M61.453 23.895c1.852-.582 2.991-2.205 2.545-3.625s-2.309-2.1-4.16-1.518c-1.852.581-2.992 2.204-2.546 3.624s2.31 2.1 4.16 1.519"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__Y)"
          d="M68.702 22.77c1.938-.1 3.447-1.39 3.37-2.882s-1.71-2.621-3.648-2.522-3.448 1.39-3.371 2.883c.077 1.492 1.71 2.62 3.649 2.52"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__Z)"
          d="M73.894 28.712c1.917.309 3.682-.76 3.944-2.385.262-1.626-1.079-3.194-2.995-3.503-1.916-.308-3.682.76-3.944 2.385-.262 1.626 1.08 3.194 2.995 3.503"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aa)"
          d="M80.757 27.172c1.783.768 3.728.229 4.345-1.204s-.328-3.216-2.11-3.984c-1.783-.768-3.729-.229-4.346 1.204s.329 3.216 2.111 3.984"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ab)"
          d="M87.43 25.62c1.619 1.07 3.566.977 4.349-.207.782-1.185.104-3.013-1.515-4.083-1.62-1.07-3.566-.977-4.35.207-.782 1.185-.104 3.013 1.515 4.083"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ac)"
          d="M93.608 24.19c1.478 1.258 3.324 1.517 4.122.58.798-.939.247-2.719-1.231-3.977s-3.324-1.517-4.122-.58c-.798.939-.247 2.719 1.231 3.977"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ad)"
          d="M98.997 22.946c1.372 1.373 3.058 1.913 3.767 1.205.708-.707.171-2.394-1.201-3.768-1.371-1.373-3.057-1.913-3.766-1.206s-.171 2.395 1.2 3.768"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ae)"
          d="M103.356 21.911c1.297 1.444 2.793 2.215 3.341 1.723.548-.493-.059-2.062-1.356-3.506s-2.793-2.215-3.341-1.723c-.548.493.059 2.063 1.356 3.506"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__af)"
          d="M106.501 21.103c1.251 1.484 2.542 2.453 2.884 2.165.342-.289-.394-1.726-1.645-3.21s-2.543-2.453-2.885-2.165c-.342.289.395 1.726 1.646 3.21"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ag)"
          d="M24.405 33.835c.706-1.809 1.152-3.323.997-3.384-.156-.06-.854 1.356-1.56 3.164-.705 1.808-1.152 3.323-.996 3.383s.853-1.355 1.56-3.163"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ah)"
          d="M26.403 33.812c.735-1.797.977-3.398.541-3.576s-1.384 1.134-2.118 2.93c-.735 1.797-.977 3.398-.541 3.576s1.384-1.134 2.118-2.93"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ai)"
          d="M29.746 33.595c.793-1.771.875-3.459.183-3.769s-1.896.875-2.69 2.646c-.793 1.772-.875 3.459-.183 3.77s1.897-.876 2.69-2.647"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aj)"
          d="M34.3 33.22c.888-1.725.873-3.503-.034-3.97-.908-.467-2.364.553-3.252 2.278-.89 1.726-.874 3.503.033 3.97s2.363-.552 3.252-2.278"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ak)"
          d="M39.88 32.733c1.03-1.645 1.008-3.515-.05-4.177-1.057-.662-2.75.134-3.78 1.78s-1.007 3.515.05 4.177c1.058.663 2.75-.134 3.78-1.78"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__al)"
          d="M46.247 32.179c1.227-1.504 1.322-3.458.212-4.363s-3.005-.42-4.232 1.084-1.321 3.457-.211 4.363c1.11.905 3.005.42 4.231-1.084"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__am)"
          d="M53.102 31.59c1.48-1.256 1.855-3.244.84-4.439s-3.038-1.146-4.517.11-1.856 3.245-.84 4.44c1.015 1.196 3.038 1.146 4.517-.11"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__an)"
          d="M60.102 30.923c1.747-.847 2.578-2.739 1.857-4.224s-2.721-2.003-4.467-1.155c-1.746.847-2.578 2.738-1.857 4.224.721 1.485 2.721 2.002 4.467 1.155"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ao)"
          d="M67.028 30.006c1.92-.28 3.281-1.852 3.04-3.512-.243-1.66-1.996-2.779-3.916-2.499-1.921.28-3.282 1.853-3.04 3.513s1.995 2.778 3.916 2.498"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ap)"
          d="M78.512 34.984c1.738.865 3.776.301 4.552-1.26.777-1.56-.002-3.526-1.74-4.39-1.738-.865-3.776-.301-4.552 1.26-.777 1.56.002 3.526 1.74 4.39"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aq)"
          d="M85.302 33.296c1.5 1.232 3.557 1.206 4.594-.057s.66-3.286-.84-4.517-3.557-1.206-4.593.057c-1.037 1.264-.661 3.286.839 4.517"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ar)"
          d="M91.9 31.76c1.314 1.428 3.26 1.776 4.35.776 1.088-1 .906-2.97-.407-4.4-1.314-1.429-3.26-1.776-4.35-.776-1.088 1-.906 2.97.407 4.4"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__as)"
          d="M97.961 30.42c1.181 1.54 2.962 2.158 3.978 1.379s.882-2.659-.299-4.2c-1.181-1.54-2.962-2.157-3.978-1.378-1.015.778-.882 2.659.3 4.199"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__at)"
          d="M103.233 29.28c1.09 1.605 2.675 2.431 3.54 1.844.864-.586.681-2.364-.409-3.97s-2.674-2.432-3.539-1.845c-.864.586-.682 2.364.408 3.97"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__au)"
          d="M107.525 28.344c1.03 1.646 2.4 2.644 3.061 2.23.661-.413.363-2.082-.667-3.728-1.03-1.645-2.4-2.643-3.061-2.23-.661.414-.362 2.083.667 3.728"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__av)"
          d="M110.691 27.619c.992 1.668 2.139 2.817 2.562 2.565s-.038-1.808-1.031-3.476-2.139-2.817-2.562-2.565.039 1.808 1.031 3.476"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aw)"
          d="M112.624 27.103c.973 1.679 1.896 2.963 2.061 2.867.164-.095-.492-1.534-1.465-3.213s-1.896-2.963-2.061-2.867c-.165.095.491 1.534 1.465 3.213"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ax)"
          d="M22.627 41.41c.41-1.896.53-3.48.266-3.538s-.81 1.435-1.222 3.332c-.41 1.897-.53 3.481-.266 3.538s.811-1.434 1.222-3.331"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ay)"
          d="M24.957 41.255c.437-1.892.342-3.528-.212-3.657-.555-.128-1.358 1.302-1.795 3.193-.437 1.89-.342 3.528.212 3.656s1.358-1.301 1.795-3.192"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__az)"
          d="M28.498 40.924c.486-1.879.212-3.575-.612-3.788-.825-.213-1.887 1.137-2.373 3.016s-.212 3.575.612 3.789c.825.213 1.887-1.138 2.373-3.017"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aA)"
          d="M33.143 40.454c.564-1.858.161-3.624-.9-3.947-1.062-.322-2.38.922-2.944 2.779s-.161 3.624.9 3.946c1.062.323 2.38-.921 2.944-2.778"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aB)"
          d="M38.743 39.889c.683-1.817.223-3.671-1.028-4.141-1.25-.47-2.817.622-3.5 2.439s-.223 3.67 1.027 4.14 2.818-.621 3.5-2.438"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aC)"
          d="M45.097 39.288c.861-1.74.452-3.698-.913-4.374s-3.17.187-4.031 1.926c-.861 1.74-.453 3.698.913 4.374 1.365.676 3.17-.187 4.03-1.926"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aD)"
          d="M51.944 38.728c1.125-1.581.935-3.647-.423-4.614-1.359-.966-3.372-.467-4.497 1.114s-.936 3.647.422 4.614c1.359.966 3.373.468 4.498-1.114"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aE)"
          d="M58.91 38.256c1.488-1.247 1.775-3.354.643-4.705-1.133-1.35-3.258-1.435-4.745-.188s-1.774 3.353-.642 4.705c1.134 1.35 3.258 1.435 4.745.188"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aF)"
          d="M65.565 37.702c1.843-.608 2.877-2.494 2.31-4.211s-2.521-2.616-4.364-2.007c-1.843.608-2.877 2.494-2.31 4.211s2.52 2.616 4.364 2.007"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aG)"
          d="M71.926 36.606c1.928.221 3.658-1.05 3.864-2.84s-1.19-3.42-3.119-3.642c-1.928-.222-3.658 1.05-3.864 2.84s1.19 3.42 3.119 3.642"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aH)"
          d="M75.899 43.052c1.62 1.068 3.766.672 4.793-.885s.546-3.685-1.075-4.754-3.766-.672-4.793.885-.546 3.685 1.075 4.753"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aI)"
          d="M82.913 41.09c1.243 1.49 3.36 1.774 4.726.633 1.366-1.14 1.466-3.273.222-4.763s-3.36-1.774-4.726-.633c-1.366 1.14-1.466 3.273-.222 4.763"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aJ)"
          d="M90.022 39.455c1.02 1.652 2.982 2.289 4.383 1.423 1.4-.865 1.709-2.905.688-4.556-1.02-1.651-2.982-2.289-4.383-1.423-1.4.865-1.709 2.905-.688 4.556"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aK)"
          d="M96.712 38.071c.888 1.727 2.665 2.582 3.971 1.91 1.305-.67 1.644-2.614.756-4.34s-2.665-2.581-3.97-1.91c-1.306.67-1.644 2.614-.757 4.34"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aL)"
          d="M102.704 36.894c.805 1.766 2.379 2.778 3.516 2.26 1.136-.518 1.405-2.37.6-4.136-.804-1.766-2.378-2.778-3.515-2.26s-1.406 2.37-.601 4.136"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aM)"
          d="M107.798 35.911c.752 1.79 2.106 2.927 3.025 2.541.918-.386 1.053-2.149.302-3.938-.752-1.79-2.106-2.928-3.025-2.542-.918.386-1.054 2.15-.302 3.939"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aN)"
          d="M111.84 35.124c.718 1.803 1.84 3.05 2.506 2.785s.623-1.942-.095-3.745-1.84-3.05-2.505-2.786c-.666.265-.624 1.942.094 3.746"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aO)"
          d="M114.714 34.54c.698 1.81 1.58 3.157 1.969 3.007.39-.15.139-1.74-.559-3.551s-1.58-3.158-1.969-3.007c-.39.15-.139 1.74.559 3.55"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aP)"
          d="M21.275 49.256c.097-1.938.008-3.518-.199-3.529-.207-.01-.453 1.553-.55 3.492-.098 1.938-.009 3.518.198 3.528s.454-1.552.551-3.49"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aQ)"
          d="M23.343 49.052c.11-1.938-.218-3.532-.732-3.562-.515-.029-1.02 1.518-1.13 3.456s.217 3.533.732 3.562c.514.03 1.02-1.518 1.13-3.456"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aR)"
          d="M26.645 48.662c.136-1.937-.409-3.552-1.216-3.608s-1.572 1.467-1.707 3.403c-.136 1.936.409 3.552 1.216 3.608.808.057 1.572-1.467 1.707-3.403"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aS)"
          d="M31.09 48.113c.178-1.933-.551-3.58-1.628-3.68-1.076-.098-2.093 1.389-2.271 3.321s.55 3.58 1.628 3.68c1.076.098 2.093-1.388 2.27-3.321"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aT)"
          d="M36.55 47.438c.245-1.926-.62-3.622-1.934-3.789-1.313-.166-2.575 1.26-2.82 3.185s.622 3.621 1.935 3.788 2.575-1.259 2.82-3.184"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aU)"
          d="M42.871 46.69c.35-1.908-.585-3.68-2.09-3.956-1.504-.277-3.008 1.047-3.359 2.956-.35 1.909.585 3.68 2.09 3.957S42.52 48.6 42.87 46.69"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aV)"
          d="M49.847 45.956c.528-1.868-.365-3.756-1.996-4.217-1.63-.46-3.38.68-3.908 2.547-.529 1.868.365 3.756 1.996 4.217 1.63.46 3.38-.68 3.908-2.547"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aW)"
          d="M57.187 45.393c.848-1.746.213-3.804-1.417-4.596s-3.64-.019-4.488 1.727-.214 3.804 1.417 4.596c1.63.792 3.64.019 4.488-1.727"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aX)"
          d="M64.269 45.246c1.43-1.312 1.56-3.5.29-4.887-1.272-1.387-3.462-1.449-4.894-.138-1.43 1.312-1.56 3.5-.29 4.887 1.272 1.387 3.463 1.449 4.894.138"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aY)"
          d="M69.985 44.919c1.94-.06 3.466-1.646 3.408-3.544-.057-1.898-1.677-3.39-3.617-3.331s-3.466 1.645-3.408 3.544c.057 1.898 1.677 3.39 3.617 3.33"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__aZ)"
          d="M79.815 48.474c.618 1.84 2.554 2.849 4.324 2.254s2.704-2.568 2.086-4.408-2.554-2.85-4.325-2.255c-1.77.595-2.704 2.569-2.085 4.409"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ba)"
          d="M87.34 47.06c.508 1.872 2.296 3.018 3.995 2.557 1.698-.46 2.663-2.352 2.155-4.225s-2.296-3.019-3.994-2.558c-1.699.46-2.664 2.352-2.156 4.225"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bb)"
          d="M94.452 45.823c.457 1.887 2.093 3.109 3.654 2.73 1.56-.378 2.455-2.214 1.998-4.1-.458-1.887-2.094-3.109-3.655-2.73-1.56.378-2.455 2.214-1.997 4.1"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bc)"
          d="M100.938 44.73c.429 1.893 1.893 3.174 3.269 2.862s2.143-2.1 1.713-3.993-1.893-3.174-3.269-2.862c-1.376.313-2.143 2.1-1.713 3.993"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bd)"
          d="M106.625 43.781c.413 1.897 1.681 3.231 2.834 2.98 1.152-.25 1.752-1.99 1.339-3.888-.413-1.896-1.681-3.23-2.834-2.98-1.152.251-1.752 1.992-1.339 3.888"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__be)"
          d="M111.361 42.995c.402 1.899 1.455 3.284 2.352 3.095.898-.19 1.299-1.884.897-3.783s-1.455-3.284-2.352-3.094-1.299 1.883-.897 3.782"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bf)"
          d="M115.025 42.383c.395 1.9 1.216 3.336 1.834 3.208.618-.129.799-1.773.404-3.674-.396-1.9-1.217-3.336-1.835-3.208-.618.129-.799 1.774-.403 3.674"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bg)"
          d="M117.519 41.96c.391 1.9.97 3.388 1.292 3.322s.266-1.661-.125-3.562c-.392-1.902-.971-3.389-1.293-3.322s-.266 1.66.126 3.562"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bh)"
          d="M22.98 56.944c-.213-1.929-.746-3.453-1.19-3.404-.443.05-.63 1.653-.416 3.582.214 1.93.747 3.453 1.191 3.404s.63-1.653.416-3.582"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bi)"
          d="M25.942 56.503c-.21-1.93-.978-3.429-1.717-3.349s-1.168 1.71-.96 3.64c.21 1.929.979 3.428 1.717 3.348.74-.08 1.169-1.71.96-3.639"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bj)"
          d="M30.04 55.887c-.201-1.93-1.187-3.41-2.203-3.304s-1.675 1.757-1.474 3.687c.2 1.93 1.187 3.41 2.202 3.304 1.015-.105 1.676-1.756 1.475-3.687"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bk)"
          d="M35.169 55.115c-.188-1.932-1.367-3.398-2.633-3.275s-2.14 1.789-1.953 3.72c.189 1.932 1.367 3.399 2.633 3.276s2.14-1.79 1.953-3.721"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bl)"
          d="M41.197 54.214c-.167-1.934-1.506-3.398-2.99-3.27-1.486.129-2.554 1.8-2.387 3.734.168 1.934 1.507 3.398 2.992 3.27 1.484-.129 2.553-1.8 2.385-3.734"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bm)"
          d="M47.969 53.22c-.132-1.937-1.59-3.415-3.256-3.301s-2.91 1.775-2.778 3.711c.132 1.937 1.59 3.415 3.256 3.301s2.91-1.775 2.778-3.711"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bn)"
          d="M55.31 52.197c-.064-1.94-1.579-3.465-3.384-3.405-1.806.059-3.218 1.68-3.154 3.62.063 1.94 1.578 3.464 3.384 3.405s3.217-1.68 3.154-3.62"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bo)"
          d="M63.02 51.302c.109-1.938-1.337-3.596-3.23-3.703-1.893-.108-3.516 1.376-3.626 3.314s1.335 3.596 3.228 3.703c1.894.108 3.517-1.376 3.627-3.314"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bp)"
          d="M70.332 51.802a3.51 3.51 0 0 0-.99-4.865 3.51 3.51 0 0 0-4.862 1 3.51 3.51 0 0 0 .989 4.865 3.51 3.51 0 0 0 4.863-1"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bq)"
          d="M72.3 50.43c1.006 1.66 3.158 2.197 4.806 1.198 1.648-.998 2.168-3.154 1.163-4.814s-3.158-2.196-4.806-1.197c-1.648.998-2.168 3.154-1.162 4.814"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__br)"
          d="M77.203 54.574c-.735 1.797.09 3.834 1.842 4.55s3.768-.16 4.502-1.957c.735-1.796-.09-3.834-1.842-4.55s-3.768.16-4.502 1.957"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bs)"
          d="M84.693 54.135c-.32 1.914.866 3.708 2.65 4.007 1.785.298 3.491-1.011 3.811-2.926.32-1.914-.866-3.708-2.65-4.007-1.785-.298-3.491 1.012-3.811 2.926"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bt)"
          d="M92.004 53.325c-.144 1.936 1.097 3.605 2.771 3.73 1.675.124 3.148-1.345 3.291-3.28.144-1.936-1.097-3.606-2.771-3.73s-3.148 1.344-3.291 3.28"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bu)"
          d="M98.803 52.45c-.05 1.94 1.128 3.545 2.633 3.584 1.504.039 2.764-1.502 2.815-3.443.05-1.94-1.129-3.544-2.633-3.584-1.505-.039-2.765 1.503-2.815 3.443"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bv)"
          d="M104.89 51.624c.005 1.94 1.056 3.511 2.348 3.508s2.336-1.579 2.331-3.52c-.005-1.94-1.056-3.512-2.348-3.509s-2.336 1.58-2.331 3.52"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bw)"
          d="M110.103 50.9c.039 1.941.919 3.497 1.964 3.476 1.046-.02 1.862-1.611 1.822-3.552-.039-1.94-.918-3.496-1.964-3.475s-1.861 1.611-1.822 3.552"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bx)"
          d="M114.305 50.32c.061 1.94.736 3.492 1.509 3.468s1.348-1.617 1.287-3.557-.737-3.492-1.509-3.468-1.348 1.616-1.287 3.556"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__by)"
          d="M117.389 49.904c.074 1.94.522 3.497 1.001 3.479s.807-1.605.732-3.545c-.074-1.94-.522-3.497-1-3.479-.479.019-.807 1.606-.733 3.545"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bz)"
          d="M119.273 49.674c.08 1.94.286 3.506.459 3.499.173-.008.248-1.586.167-3.525-.08-1.94-.285-3.506-.458-3.498s-.249 1.585-.168 3.524"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bA)"
          d="M23.45 64.825c-.525-1.868-1.178-3.32-1.458-3.24-.281.078-.083 1.657.441 3.525.525 1.87 1.177 3.32 1.458 3.242.28-.08.083-1.658-.442-3.527"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bB)"
          d="M25.78 64.386c-.534-1.866-1.428-3.247-1.999-3.084-.57.163-.6 1.808-.068 3.674.533 1.867 1.427 3.247 1.998 3.085.57-.163.601-1.808.068-3.675"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bC)"
          d="M29.279 63.756c-.549-1.862-1.677-3.17-2.521-2.921-.844.248-1.084 1.96-.536 3.821s1.677 3.17 2.521 2.921c.844-.248 1.084-1.96.536-3.821"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bD)"
          d="M33.855 62.94c-.573-1.854-1.924-3.083-3.017-2.745-1.093.337-1.514 2.114-.94 3.969.573 1.854 1.923 3.084 3.016 2.746s1.514-2.115.94-3.97"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bE)"
          d="M39.386 61.952c-.613-1.842-2.169-2.983-3.477-2.548s-1.87 2.28-1.258 4.122 2.169 2.983 3.476 2.548c1.308-.435 1.871-2.28 1.259-4.122"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bF)"
          d="M45.719 60.791c-.675-1.82-2.421-2.85-3.899-2.301s-2.128 2.468-1.453 4.288 2.42 2.85 3.899 2.301c1.478-.548 2.128-2.468 1.453-4.288"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bG)"
          d="M52.665 59.446c-.784-1.776-2.706-2.647-4.292-1.947s-2.237 2.708-1.453 4.483c.784 1.776 2.706 2.647 4.292 1.947s2.237-2.708 1.453-4.483"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bH)"
          d="M59.963 57.84c-.998-1.665-3.092-2.245-4.676-1.295s-2.059 3.069-1.06 4.734c.997 1.664 3.09 2.244 4.674 1.295s2.06-3.07 1.061-4.734"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bI)"
          d="M66.95 55.667c-1.502-1.23-3.7-1.027-4.912.453-1.21 1.479-.974 3.675.528 4.904 1.501 1.23 3.7 1.027 4.912-.453 1.21-1.48.974-3.675-.528-4.904"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bJ)"
          d="M71.17 53.917c-1.773.787-2.577 2.854-1.795 4.615s2.854 2.55 4.628 1.763 2.578-2.854 1.796-4.615-2.854-2.55-4.628-1.763"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bK)"
          d="M82.507 61.06c-1.174 1.547-.965 3.681.466 4.768s3.544.716 4.718-.83.965-3.68-.467-4.767-3.543-.716-4.717.83"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bL)"
          d="M89.616 60.602c-.808 1.764-.218 3.765 1.319 4.468 1.536.704 3.437-.157 4.245-1.921s.217-3.766-1.32-4.47c-1.536-.703-3.436.158-4.244 1.922"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bM)"
          d="M96.495 59.971c-.582 1.852.134 3.726 1.6 4.187 1.464.46 3.124-.668 3.705-2.52.582-1.852-.134-3.726-1.599-4.186s-3.125.668-3.706 2.52"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bN)"
          d="M102.803 59.303c-.44 1.89.261 3.67 1.566 3.973 1.305.304 2.72-.982 3.16-2.873.44-1.89-.261-3.669-1.566-3.973s-2.719.983-3.16 2.873"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bO)"
          d="M108.315 58.681c-.349 1.91.251 3.619 1.341 3.818s2.255-1.187 2.604-3.097-.251-3.618-1.34-3.817-2.256 1.187-2.605 3.096"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bP)"
          d="M112.861 58.166c-.29 1.919.152 3.577.987 3.703.835.127 1.748-1.327 2.038-3.246.291-1.919-.151-3.577-.986-3.703-.836-.127-1.748 1.326-2.039 3.246"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bQ)"
          d="M116.31 57.795c-.254 1.925-.011 3.544.544 3.617.554.073 1.209-1.427 1.463-3.352s.011-3.543-.543-3.616c-.555-.074-1.21 1.427-1.464 3.351"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bR)"
          d="M118.559 57.6c-.235 1.927-.217 3.514.039 3.545s.654-1.505.889-3.432.217-3.514-.039-3.545-.654 1.505-.889 3.432"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bS)"
          d="M26.583 72.118c-.822-1.758-1.751-3.061-2.074-2.91s.083 1.699.906 3.457c.822 1.758 1.75 3.06 2.074 2.91.322-.152-.083-1.7-.906-3.457"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bT)"
          d="M29.176 71.54c-.845-1.747-2.007-2.933-2.595-2.648s-.38 1.931.465 3.678c.845 1.748 2.007 2.934 2.595 2.65s.38-1.932-.465-3.68"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bU)"
          d="M32.933 70.762c-.884-1.729-2.273-2.785-3.103-2.36-.83.424-.787 2.169.097 3.897s2.273 2.785 3.103 2.36c.83-.424.787-2.17-.097-3.898"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bV)"
          d="M37.74 69.783c-.945-1.695-2.551-2.602-3.587-2.025s-1.11 2.42-.166 4.115 2.55 2.602 3.586 2.025 1.11-2.42.166-4.115"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bW)"
          d="M43.444 68.608c-1.036-1.641-2.841-2.362-4.03-1.61-1.19.751-1.314 2.691-.278 4.332 1.037 1.64 2.842 2.361 4.032 1.61s1.313-2.692.276-4.332"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bX)"
          d="M49.854 67.228c-1.178-1.543-3.157-2.011-4.421-1.047s-1.334 2.998-.157 4.54c1.178 1.544 3.157 2.013 4.421 1.048s1.334-2.998.157-4.54"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bY)"
          d="M56.693 65.627c-1.393-1.351-3.499-1.44-4.703-.198s-1.05 3.343.343 4.695c1.393 1.35 3.499 1.44 4.703.198s1.05-3.344-.343-4.695"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__bZ)"
          d="M63.536 63.806c-1.7-.935-3.791-.4-4.67 1.197-.877 1.597-.21 3.65 1.49 4.585s3.791.4 4.67-1.197c.877-1.597.21-3.65-1.49-4.585"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ca)"
          d="M69.792 62.102c-1.94-.074-3.57 1.376-3.641 3.24-.072 1.863 1.443 3.433 3.382 3.508 1.94.074 3.57-1.376 3.641-3.24.072-1.863-1.443-3.434-3.382-3.508"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cb)"
          d="M75.765 61.333c-1.68.973-2.287 3.064-1.356 4.67.93 1.607 3.046 2.12 4.726 1.147s2.286-3.064 1.356-4.67-3.047-2.12-4.726-1.147"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cc)"
          d="M80.328 68.411c-1.66 1.007-2.279 3.02-1.383 4.497s2.968 1.856 4.627.849c1.66-1.007 2.278-3.02 1.382-4.496s-2.967-1.857-4.626-.85"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cd)"
          d="M87.435 67.845c-1.327 1.417-1.431 3.474-.235 4.593 1.197 1.12 3.242.88 4.569-.538 1.326-1.417 1.43-3.474.234-4.594-1.197-1.12-3.242-.879-4.568.538"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ce)"
          d="M94.45 67.277c-1.048 1.633-.875 3.613.386 4.423s3.134.141 4.182-1.492.876-3.614-.386-4.424c-1.261-.81-3.133-.141-4.182 1.492"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cf)"
          d="M100.987 66.694c-.849 1.745-.583 3.624.595 4.198 1.179.573 2.822-.377 3.671-2.123.85-1.745.583-3.624-.595-4.198-1.178-.573-2.822.377-3.671 2.123"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cg)"
          d="M106.734 66.152c-.713 1.805-.477 3.59.527 3.987 1.004.396 2.396-.745 3.109-2.55s.478-3.59-.526-3.987-2.396.745-3.11 2.55"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ch)"
          d="M111.461 65.714c-.624 1.838-.504 3.54.267 3.802s1.902-1.016 2.525-2.854c.624-1.838.505-3.54-.266-3.802-.771-.261-1.902 1.016-2.526 2.854"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ci)"
          d="M114.991 65.431c-.568 1.856-.624 3.484-.124 3.638.499.153 1.365-1.228 1.934-3.084.568-1.856.624-3.484.124-3.637s-1.366 1.227-1.934 3.083"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cj)"
          d="M117.2 65.335c-.541 1.864-.812 3.424-.606 3.484s.811-1.404 1.351-3.268c.541-1.864.812-3.424.606-3.483s-.811 1.403-1.351 3.267"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ck)"
          d="M29.906 79.126c-1.092-1.605-2.15-2.788-2.363-2.643s.499 1.564 1.591 3.168 2.15 2.788 2.363 2.643-.499-1.563-1.591-3.168"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cl)"
          d="M32.224 78.503c-1.12-1.586-2.4-2.608-2.862-2.282-.461.325.072 1.875 1.192 3.46 1.119 1.586 2.4 2.608 2.861 2.282.461-.325-.072-1.874-1.191-3.46"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cm)"
          d="M35.842 77.65c-1.17-1.548-2.67-2.387-3.35-1.873s-.284 2.186.886 3.735 2.67 2.388 3.35 1.874.284-2.186-.886-3.735"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cn)"
          d="M40.626 76.575c-1.25-1.485-2.954-2.108-3.806-1.39-.853.716-.53 2.501.719 3.987 1.249 1.485 2.953 2.108 3.805 1.391s.53-2.502-.718-3.988"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__co)"
          d="M46.381 75.284c-1.366-1.379-3.244-1.733-4.196-.791s-.615 2.824.75 4.203c1.366 1.38 3.244 1.734 4.196.791.952-.942.616-2.824-.75-4.203"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cp)"
          d="M52.86 73.794c-1.527-1.199-3.526-1.2-4.465-.003s-.462 3.138 1.065 4.336 3.526 1.2 4.465.003.462-3.138-1.065-4.337"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cq)"
          d="M59.742 72.15c-1.728-.884-3.74-.406-4.493 1.068-.753 1.473.038 3.383 1.766 4.267 1.728.883 3.74.405 4.493-1.069s-.038-3.383-1.766-4.266"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cr)"
          d="M66.663 70.51c-1.908-.358-3.713.734-4.033 2.44-.32 1.704.967 3.376 2.875 3.734s3.713-.734 4.033-2.439-.967-3.377-2.875-3.735"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cs)"
          d="M73.443 69.208c-1.908.355-3.194 2.044-2.873 3.774.322 1.729 2.129 2.843 4.037 2.488 1.909-.354 3.195-2.044 2.873-3.773s-2.129-2.844-4.037-2.489"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ct)"
          d="M84.686 75.06c-1.65 1.024-2.329 2.913-1.517 4.22.81 1.307 2.805 1.537 4.455.513 1.648-1.024 2.328-2.913 1.516-4.22-.81-1.307-2.805-1.536-4.454-.513"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cu)"
          d="M91.743 74.4c-1.407 1.336-1.756 3.254-.779 4.283.978 1.029 2.91.78 4.318-.558 1.407-1.336 1.756-3.254.779-4.283-.978-1.029-2.91-.78-4.318.558"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cv)"
          d="M98.367 73.82c-1.199 1.527-1.376 3.389-.396 4.157.98.77 2.745.154 3.943-1.372 1.199-1.527 1.376-3.388.396-4.157s-2.745-.154-3.943 1.373"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cw)"
          d="M104.221 73.324c-1.041 1.639-1.184 3.412-.32 3.96.864.55 2.408-.333 3.449-1.972 1.041-1.638 1.184-3.411.32-3.96-.865-.55-2.409.334-3.449 1.972"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cx)"
          d="M109.019 72.95c-.932 1.703-1.145 3.38-.475 3.747.669.366 1.967-.718 2.898-2.42.932-1.703 1.144-3.38.475-3.747-.669-.366-1.967.718-2.898 2.42"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cy)"
          d="M112.538 72.747c-.863 1.738-1.22 3.318-.797 3.528s1.467-1.028 2.33-2.766c.864-1.739 1.221-3.318.797-3.528-.423-.21-1.466 1.028-2.33 2.766"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cz)"
          d="M114.62 72.75c-.831 1.754-1.384 3.233-1.235 3.303s.942-1.294 1.773-3.049 1.384-3.233 1.235-3.303-.942 1.295-1.773 3.049"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cA)"
          d="M34.384 85.472c-1.332-1.412-2.5-2.473-2.61-2.37s.882 1.331 2.213 2.743c1.332 1.412 2.5 2.474 2.61 2.37.109-.103-.882-1.331-2.213-2.743"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cB)"
          d="M36.297 84.836c-1.356-1.388-2.722-2.253-3.05-1.932-.33.32.504 1.706 1.86 3.095 1.358 1.388 2.724 2.252 3.052 1.931.329-.32-.505-1.706-1.862-3.094"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cC)"
          d="M39.646 83.956c-1.41-1.335-2.97-1.975-3.486-1.43-.516.544.208 2.068 1.617 3.403s2.97 1.975 3.486 1.43-.208-2.069-1.617-3.403"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cD)"
          d="M44.273 82.837c-1.491-1.242-3.226-1.618-3.874-.84s.035 2.417 1.527 3.659 3.226 1.617 3.874.839c.649-.779-.035-2.416-1.527-3.658"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cE)"
          d="M49.952 81.509c-1.606-1.09-3.47-1.145-4.165-.123s.044 2.737 1.65 3.827 3.47 1.145 4.165.122-.044-2.736-1.65-3.826"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cF)"
          d="M56.404 80.017c-1.745-.85-3.661-.51-4.28.76-.618 1.27.295 2.989 2.04 3.839s3.661.509 4.28-.761c.618-1.27-.295-2.988-2.04-3.838"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cG)"
          d="M63.307 78.465c-1.88-.484-3.714.329-4.096 1.814s.832 3.083 2.712 3.566c1.88.484 3.713-.329 4.095-1.814s-.832-3.083-2.711-3.566"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cH)"
          d="M70.381 77.031c-1.94.015-3.504 1.321-3.492 2.918s1.595 2.88 3.536 2.865 3.505-1.321 3.493-2.918-1.596-2.88-3.537-2.865"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cI)"
          d="M77.514 75.893c-1.858.563-2.988 2.259-2.525 3.789s2.344 2.313 4.202 1.75c1.858-.562 2.988-2.258 2.525-3.788s-2.345-2.313-4.202-1.75"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cJ)"
          d="M81.448 81.967c-1.819.676-2.902 2.277-2.42 3.574.483 1.298 2.35 1.8 4.168 1.124 1.82-.677 2.903-2.277 2.42-3.575-.483-1.297-2.349-1.8-4.168-1.124"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cK)"
          d="M88.69 81.133c-1.644 1.033-2.42 2.756-1.733 3.848s2.575 1.14 4.218.106 2.419-2.755 1.733-3.847c-.687-1.092-2.576-1.14-4.219-.107"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cL)"
          d="M95.468 80.482c-1.458 1.281-2.035 3.008-1.289 3.858.746.849 2.533.499 3.991-.782s2.036-3.008 1.29-3.858c-.747-.849-2.533-.499-3.992.782"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cM)"
          d="M101.413 79.987c-1.303 1.439-1.81 3.103-1.132 3.717s2.283-.055 3.586-1.494c1.303-1.438 1.81-3.102 1.132-3.716s-2.283.055-3.586 1.493"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cN)"
          d="M106.166 79.666c-1.191 1.533-1.738 3.1-1.223 3.5.516.401 1.899-.517 3.09-2.05s1.739-3.099 1.223-3.5c-.515-.4-1.899.518-3.09 2.05"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cO)"
          d="M109.448 79.561c-1.123 1.583-1.797 3.034-1.505 3.242.292.207 1.439-.908 2.563-2.491 1.123-1.583 1.796-3.035 1.504-3.242s-1.439.908-2.562 2.491"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cP)"
          d="M40.853 90.542c-1.548-1.17-2.935-1.945-3.097-1.73-.163.215.961 1.337 2.51 2.507s2.936 1.944 3.098 1.73c.162-.215-.962-1.337-2.51-2.507"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cQ)"
          d="M43.541 89.707c-1.59-1.114-3.143-1.64-3.47-1.172s.695 1.749 2.284 2.863c1.59 1.115 3.143 1.64 3.47 1.172.328-.466-.695-1.748-2.284-2.863"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cR)"
          d="M47.764 88.61c-1.659-1.007-3.358-1.24-3.796-.52s.552 2.122 2.21 3.13c1.659 1.008 3.359 1.24 3.796.52.438-.72-.551-2.121-2.21-3.13"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cS)"
          d="M53.26 87.296c-1.753-.834-3.547-.724-4.009.246-.46.97.586 2.43 2.34 3.265 1.752.834 3.547.724 4.008-.246s-.586-2.43-2.339-3.265"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cT)"
          d="M59.703 85.84c-1.856-.57-3.658-.064-4.025 1.131s.84 2.626 2.695 3.196 3.657.064 4.024-1.131-.84-2.626-2.694-3.196"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cU)"
          d="M66.737 84.37c-1.93-.203-3.61.73-3.754 2.087s1.305 2.622 3.235 2.826 3.611-.73 3.755-2.087c.143-1.356-1.305-2.621-3.236-2.825"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cV)"
          d="M74.059 83.042c-1.927.238-3.348 1.565-3.176 2.964.173 1.399 1.875 2.34 3.8 2.102 1.927-.237 3.349-1.564 3.176-2.963-.172-1.4-1.874-2.34-3.8-2.103"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cW)"
          d="M85.028 87.29c-1.791.747-2.895 2.189-2.464 3.22.43 1.033 2.23 1.263 4.022.516s2.895-2.189 2.465-3.22-2.231-1.263-4.023-.516"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cX)"
          d="M91.852 86.54c-1.648 1.025-2.563 2.533-2.044 3.368.52.834 2.276.68 3.924-.345s2.564-2.533 2.045-3.367-2.276-.68-3.925.344"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cY)"
          d="M97.774 86.02c-1.513 1.217-2.343 2.696-1.853 3.305s2.112.117 3.625-1.1c1.513-1.216 2.342-2.695 1.853-3.304s-2.113-.117-3.625 1.1"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__cZ)"
          d="M102.352 85.742c-1.41 1.333-2.261 2.724-1.9 3.106.361.383 1.798-.388 3.209-1.721 1.41-1.333 2.261-2.724 1.9-3.106-.362-.383-1.798.388-3.209 1.721"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__da)"
          d="M105.232 85.737c-1.352 1.392-2.312 2.654-2.143 2.818.169.163 1.402-.833 2.754-2.225s2.311-2.654 2.143-2.818-1.402.832-2.754 2.225"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__db)"
          d="M48.428 94.524c-1.73-.88-3.27-1.322-3.44-.989s1.096 1.317 2.826 2.197 3.27 1.322 3.44.988c.17-.333-1.096-1.316-2.826-2.196"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dc)"
          d="M52 93.507c-1.78-.774-3.434-.919-3.693-.322-.26.597.972 1.708 2.752 2.483 1.78.774 3.433.919 3.692.322.26-.596-.972-1.708-2.752-2.483"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dd)"
          d="M57.119 92.257c-1.848-.595-3.565-.397-3.836.444-.27.84 1.007 2.004 2.855 2.6 1.847.595 3.564.397 3.835-.444.27-.84-1.007-2.004-2.855-2.6"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__de)"
          d="M63.399 90.877c-1.913-.331-3.609.243-3.79 1.282-.18 1.04 1.225 2.151 3.137 2.483 1.913.331 3.61-.242 3.79-1.282s-1.225-2.151-3.137-2.483"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__df)"
          d="M70.41 89.503c-1.94.011-3.508.957-3.502 2.112s1.586 2.083 3.527 2.071c1.94-.01 3.509-.957 3.502-2.112s-1.585-2.082-3.526-2.071"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dg)"
          d="M77.745 88.28c-1.9.393-3.249 1.645-3.01 2.798.237 1.152 1.971 1.768 3.872 1.375 1.9-.392 3.249-1.645 3.01-2.797-.237-1.153-1.971-1.769-3.872-1.376"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dh)"
          d="M81.035 92.637c-1.876.497-3.21 1.606-2.98 2.476.231.87 1.94 1.173 3.815.676 1.877-.497 3.21-1.606 2.98-2.476s-1.939-1.173-3.815-.676"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__di)"
          d="M88.376 91.729c-1.767.803-2.935 2.034-2.61 2.75s2.021.645 3.788-.158 2.936-2.034 2.611-2.75-2.022-.645-3.789.158"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dj)"
          d="M94.49 91.172c-1.653 1.018-2.748 2.241-2.445 2.733.303.491 1.888.065 3.54-.953s2.748-2.241 2.445-2.733c-.302-.491-1.888-.064-3.54.953"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dk)"
          d="M98.62 91.006c-1.572 1.138-2.705 2.256-2.53 2.498s1.592-.484 3.164-1.622 2.706-2.256 2.531-2.498-1.592.484-3.165 1.622"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dl)"
          d="M55.586 97.772c-1.85-.587-3.43-.808-3.53-.495s1.32 1.043 3.17 1.63c1.85.586 3.43.808 3.53.494.1-.313-1.32-1.042-3.17-1.63"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dm)"
          d="M59.794 96.622c-1.89-.438-3.534-.318-3.67.269-.135.586 1.288 1.416 3.179 1.854 1.89.437 3.534.317 3.67-.27.135-.586-1.288-1.416-3.179-1.853"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dn)"
          d="M65.943 95.248c-1.932-.189-3.561.306-3.64 1.104-.077.799 1.426 1.599 3.357 1.787 1.932.189 3.561-.306 3.64-1.104.077-.799-1.426-1.599-3.358-1.787"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__do)"
          d="M73.29 93.851c-1.936.143-3.451.99-3.385 1.894s1.69 1.52 3.625 1.378 3.451-.99 3.385-1.894-1.69-1.52-3.625-1.378"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dp)"
          d="M83.93 96.009c-1.853.575-3.218 1.485-3.049 2.033s1.81.525 3.665-.05c1.853-.575 3.219-1.485 3.049-2.032-.17-.548-1.81-.526-3.665.049"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dq)"
          d="M89.914 95.421c-1.77.798-3.076 1.73-2.918 2.08.159.35 1.72-.013 3.49-.811 1.77-.799 3.075-1.73 2.917-2.08s-1.72.013-3.49.811"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dr)"
          d="M64.039 99.613c-1.925-.247-3.52-.18-3.563.15-.042.33 1.484.798 3.41 1.045 1.924.247 3.52.18 3.562-.15s-1.484-.798-3.41-1.045"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__ds)"
          d="M69.438 98.361c-1.941-.031-3.521.385-3.53.929s1.557 1.011 3.498 1.042c1.94.031 3.521-.384 3.53-.929.009-.544-1.558-1.01-3.498-1.042"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dt)"
          d="M76.58 97.055c-1.922.271-3.409.997-3.32 1.622.087.625 1.717.912 3.639.641 1.922-.27 3.409-.996 3.32-1.621-.088-.626-1.717-.913-3.639-.642"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__du)"
          d="M79.323 99.188c-1.906.367-3.401.922-3.34 1.241.061.318 1.656.279 3.562-.087 1.906-.367 3.401-.922 3.34-1.24-.061-.32-1.656-.28-3.562.086"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dv)"
          d="M85.154 98.582c-1.85.59-3.31 1.187-3.264 1.333s1.583-.215 3.432-.805 3.31-1.187 3.264-1.333-1.583.215-3.432.805"
        />
        <path
          fill="url(#caseysindoorgolfclub_svg__dw)"
          d="M72.409 100.42c-1.94.089-3.502.364-3.49.615s1.592.383 3.531.295 3.502-.364 3.49-.615-1.592-.383-3.531-.295"
        />
      </g>
      <path
        fill="url(#caseysindoorgolfclub_svg__dx)"
        d="M70.19 101.373c27.43 0 49.666-22.236 49.666-49.665 0-27.43-22.236-49.665-49.665-49.665-27.43 0-49.666 22.236-49.666 49.665 0 27.43 22.236 49.665 49.666 49.665"
      />
      <path
        fill="#6D9B28"
        stroke="#EFEAD1"
        strokeLinejoin="round"
        strokeWidth={0.198}
        d="M45.928 27.287c13.461-4.276 34.683-4.276 48.461 0L79.344 39.165H60.973z"
      />
      <path
        fill="#0A2E0B"
        stroke="#EFEAD1"
        strokeWidth={0.182}
        d="M70.08 32.893c1.854 0 3.358-.666 3.358-1.488 0-.823-1.504-1.489-3.358-1.489s-3.357.666-3.357 1.489c0 .822 1.503 1.488 3.357 1.488Z"
      />
      <path
        fill="#F4F2E3"
        d="M70.079 32.252c1.224 0 2.217-.33 2.217-.736 0-.407-.993-.737-2.218-.737-1.224 0-2.217.33-2.217.737s.993.736 2.218.736"
      />
      <path
        fill="#0B3006"
        stroke="#EFEAD1"
        strokeLinejoin="round"
        strokeWidth={0.135}
        d="m70.38 8.52 8.68 3.579-8.68 3.136z"
      />
      <path
        stroke="#EFEAD1"
        strokeLinecap="round"
        strokeWidth={1.267}
        d="M70.08 7.902v22.964"
      />
      <path
        stroke="#0B3006"
        strokeLinecap="round"
        strokeWidth={0.919}
        d="M70.08 7.902v22.964"
      />
      <path
        fill="#0B3006"
        d="M70.079 8.9c.437 0 .792-.432.792-.965 0-.534-.355-.966-.792-.966s-.792.432-.792.966c0 .533.355.966.792.966"
      />
      <mask
        id="caseysindoorgolfclub_svg__dy"
        width={100}
        height={101}
        x={20}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M70.19 101.464c27.482 0 49.76-22.279 49.76-49.76 0-27.482-22.278-49.76-49.76-49.76s-49.76 22.278-49.76 49.76 22.278 49.76 49.76 49.76"
        />
      </mask>
      <g mask="url(#caseysindoorgolfclub_svg__dy)">
        <path
          fill="url(#caseysindoorgolfclub_svg__dz)"
          d="M15.045 74.322c33.891-9.661 76.493-9.661 110.226 0v8.235c-33.733-10.61-76.335-10.61-110.226 0z"
        />
      </g>
      <path
        fill="#0A2E0B"
        stroke="#EFEAD1"
        strokeLinejoin="round"
        strokeWidth={0.214}
        d="M15.125 46.295c33.812-9.93 76.414-9.93 110.068 0v28.507c-33.654-9.708-76.256-9.708-110.068 0z"
      />
      <path
        fill="url(#caseysindoorgolfclub_svg__dA)"
        stroke="#AC7B38"
        strokeWidth={0.174}
        d="M16.629 47.323c32.783-9.392 74.276-9.392 107.059 0V72.9c-32.783-9.297-74.276-9.297-107.06 0z"
      />
      <mask
        id="caseysindoorgolfclub_svg__dB"
        width={108}
        height={33}
        x={16}
        y={40}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M16.629 47.323c32.783-9.392 74.276-9.392 107.059 0V72.9c-32.783-9.297-74.276-9.297-107.06 0z"
        />
      </mask>
      <g mask="url(#caseysindoorgolfclub_svg__dB)">
        <path
          stroke="#402605"
          strokeOpacity={0.15}
          strokeWidth={0.187}
          d="M15.52 48.034c17.737-4.588 29.14-6.953 48.936-6.969 23.28-.628 39.435 2.043 60.498 7.127"
        />
        <path
          stroke="#B98835"
          strokeOpacity={0.18}
          strokeWidth={0.127}
          d="M15.52 48.383c17.737-4.588 29.14-6.952 48.936-6.968 23.28-.629 39.435 2.043 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.135}
          strokeWidth={0.204}
          d="M15.52 49.507c17.737-3.829 29.14-6.737 48.936-6.968 23.28.13 39.435 1.828 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.169}
          strokeWidth={0.204}
          d="M15.52 50.98c17.737-4.283 29.14-7.243 48.936-6.97 23.28-.322 39.435 2.334 60.498 7.128"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.191}
          strokeWidth={0.152}
          d="M15.52 52.453c17.737-3.725 29.14-6.454 48.936-6.969 23.28.235 39.435 1.544 60.498 7.127"
        />
        <path
          stroke="#B98835"
          strokeOpacity={0.18}
          strokeWidth={0.127}
          d="M15.52 52.8c17.737-3.724 29.14-6.453 48.936-6.968 23.28.234 39.435 1.544 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.197}
          strokeWidth={0.207}
          d="M15.52 53.925c17.737-4.262 29.14-6.66 48.936-6.968 23.28-.303 39.435 1.75 60.498 7.126"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.193}
          strokeWidth={0.174}
          d="M15.52 55.399c17.737-4.329 29.14-7.032 48.936-6.969 23.28-.369 39.435 2.123 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.144}
          strokeWidth={0.152}
          d="M15.52 56.872c17.737-4.808 29.14-6.62 48.936-6.968 23.28-.85 39.435 1.71 60.498 7.127"
        />
        <path
          stroke="#B98835"
          strokeOpacity={0.18}
          strokeWidth={0.127}
          d="M15.52 57.22c17.737-4.808 29.14-6.62 48.936-6.969 23.28-.848 39.435 1.71 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.145}
          strokeWidth={0.176}
          d="M15.52 58.344c17.737-4.889 29.14-6.686 48.936-6.968 23.28-.93 39.435 1.777 60.498 7.126"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.179}
          strokeWidth={0.225}
          d="M15.52 59.818c17.737-4.236 29.14-7.017 48.936-6.968 23.28-.277 39.435 2.108 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.122}
          strokeWidth={0.171}
          d="M15.52 61.29c17.737-4.519 29.14-7.164 48.936-6.968 23.28-.56 39.435 2.256 60.498 7.127"
        />
        <path
          stroke="#B98835"
          strokeOpacity={0.18}
          strokeWidth={0.127}
          d="M15.52 61.639c17.737-4.52 29.14-7.165 48.936-6.969 23.28-.56 39.435 2.255 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.202}
          strokeWidth={0.214}
          d="M15.52 62.763c17.737-4.16 29.14-7.19 48.936-6.968 23.28-.202 39.435 2.28 60.498 7.126"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.134}
          strokeWidth={0.196}
          d="M15.52 64.235c17.737-4.807 29.14-6.929 48.936-6.969 23.28-.847 39.435 2.02 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.198}
          strokeWidth={0.173}
          d="M15.52 65.71c17.737-3.78 29.14-7.197 48.936-6.969 23.28.18 39.435 2.287 60.498 7.127"
        />
        <path
          stroke="#B98835"
          strokeOpacity={0.18}
          strokeWidth={0.127}
          d="M15.52 66.057c17.737-3.779 29.14-7.196 48.936-6.968 23.28.18 39.435 2.287 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.194}
          strokeWidth={0.16}
          d="M15.52 67.181c17.737-4.657 29.14-6.89 48.936-6.968 23.28-.699 39.435 1.981 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.204}
          strokeWidth={0.181}
          d="M15.52 68.654c17.737-3.896 29.14-6.766 48.936-6.968 23.28.063 39.435 1.856 60.498 7.126"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.217}
          strokeWidth={0.217}
          d="M15.52 70.127c17.737-4.069 29.14-6.84 48.936-6.969 23.28-.109 39.435 1.931 60.498 7.127"
        />
        <path
          stroke="#B98835"
          strokeOpacity={0.18}
          strokeWidth={0.127}
          d="M15.52 70.476c17.737-4.068 29.14-6.84 48.936-6.968 23.28-.11 39.435 1.93 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.139}
          strokeWidth={0.228}
          d="M15.52 71.601c17.737-4.205 29.14-6.49 48.936-6.968 23.28-.246 39.435 1.58 60.498 7.127"
        />
        <path
          stroke="#402605"
          strokeOpacity={0.174}
          strokeWidth={0.219}
          d="M15.52 73.072c17.737-3.854 29.14-7.074 48.936-6.968 23.28.105 39.435 2.165 60.498 7.127"
        />
      </g>
      <path
        fill="#F4F2E3"
        fillRule="evenodd"
        stroke="#20200B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.348}
        d="M111.018 66.54c-1.025-.166-2.832-.994-3.707-1.7l-.619-.5-.296.318c-.329.354-.971.566-1.229.407-.195-.121-.238-6.199-.044-6.319.067-.041.366-.026.664.035l.541.11.185.726c.812 3.184 4.078 5.529 5.495 3.945 1.002-1.12.487-2.087-2.875-5.392-3.094-3.043-3.682-3.953-3.79-5.876-.241-4.265 4.253-6.188 7.792-3.333l.613.494.42-.3c.271-.193.573-.27.852-.216l.433.082v5.506h-.328c-.433 0-.939-.28-.94-.52 0-.449-.981-2.213-1.612-2.9-1.533-1.669-3.614-1.545-3.614.215 0 .919.646 1.785 2.963 3.978 3.495 3.306 4.492 5.034 4.27 7.402-.2 2.147-1.313 3.463-3.202 3.783-.344.058-.733.127-.863.151-.131.025-.63-.018-1.109-.096m-84.48-.613c-2.284-.892-3.463-3.606-3.471-7.995-.007-3.131.635-5.205 2.306-7.452 1.639-2.205 4.567-3.263 6.83-2.468l.838.294.364-.294c.2-.162.606-.294.904-.294h.54l-.043 2.494-.043 2.494-.508.05-.507.048-.4-.79c-1.024-2.02-2.892-2.65-4.27-1.44-1.175 1.032-1.618 3.247-1.48 7.385.13 3.818.629 5.2 2.08 5.749 1.295.49 3.44-1.49 3.823-3.53.124-.663.124-.664.826-.814l.515-.11v4.733l-.594.409c-2.357 1.624-5.747 2.297-7.71 1.531m10.046-1.312c0-.114.255-.452.568-.752.848-.815 1.067-1.357 2.186-5.398.564-2.035 1.386-4.973 1.827-6.53.955-3.364.958-3.412.25-4.197-.906-1.002-.87-1.027 2.018-1.416 1.416-.191 2.66-.347 2.766-.347.298 0 .447.378 1.477 3.747.53 1.728 1.238 4.033 1.575 5.122s.842 2.728 1.12 3.643c.645 2.11 1.112 3.037 1.811 3.595.77.614.732.954-.117 1.071-.988.136-6.183.718-6.414.718-.38 0-.195-.575.356-1.108.395-.383.554-.676.554-1.022 0-.459-.54-2.58-.697-2.737-.101-.102-3.951.43-4.074.563-.055.06-.262.734-.462 1.5l-.361 1.392.58.594c.962.986.895 1.038-1.835 1.426-2.816.4-3.128.413-3.128.136m7.52-7.732 1.199-.178-.11-.337c-.06-.185-.409-1.543-.776-3.018-.397-1.596-.703-2.558-.757-2.376-.24.81-1.375 5.638-1.375 5.848 0 .287.248.295 1.82.061m45.376 6.398c-1.612-.128-2.986-.285-3.054-.35-.2-.187.013-.541.532-.88.77-.505.844-.776.91-3.372l.062-2.42-1.467-3.202c-2.744-5.988-2.956-6.406-3.616-7.122-1.105-1.2-1.16-1.185 3.465-.901 3.92.24 4.023.285 2.918 1.291-.46.42-.55.597-.48.948.111.558 2.353 5.987 2.472 5.987.05 0 .208-.302.352-.673.144-.37.619-1.492 1.055-2.494 1.108-2.548 1.107-2.538.427-3.29-1.101-1.22-.88-1.3 2.442-.907 1.089.13 2.015.237 2.059.239.043.002.183.07.31.15.185.117.07.314-.583 1.005-.658.695-1.21 1.653-2.884 4.998l-2.07 4.138v1.88c0 2.84.085 3.232.894 4.132 1.14 1.268 1.257 1.242-3.744.843m-31.344-.368c-.645-.169-1.398-.44-1.673-.602l-.5-.296-.581.532c-.337.31-.748.533-.98.533h-.397v-6.177l.356-.002a3.2 3.2 0 0 0 .68-.09c.27-.072.382.057.69.802.451 1.087 1.692 2.48 2.605 2.921 1.697.822 3.587-.023 3.587-1.604 0-1.138-.69-1.956-3.088-3.656-3.351-2.377-4.428-3.848-4.432-6.052-.006-3.003 2.054-4.91 5.303-4.91h1.504l.928.435.927.434.443-.315c.244-.174.659-.316.921-.316h.478l.102.99c.056.544.08 1.774.052 2.732l-.05 1.742-.396.022c-.614.033-.877-.185-1.094-.908-.264-.882-1.641-2.27-2.484-2.504-1.116-.31-1.627-.226-2.218.365-1.243 1.243-.466 2.508 3.025 4.926 2.961 2.051 4.034 3.54 4.164 5.775l.07 1.227-.436.972c-.765 1.706-2.368 2.836-4.51 3.181-1.36.218-1.613.205-2.995-.157m18.199-.317c-1.699-.06-4.282-.117-5.741-.129l-2.653-.021v-.284c0-.156.32-.598.713-.983l.713-.7-.004-6.658-.003-6.658-.293-.633c-.16-.349-.48-.807-.709-1.018-.23-.21-.417-.516-.417-.678v-.294l6.137.045 6.137.044.043 2.574.044 2.573h-.954l-.463-.91c-.897-1.765-1.718-2.235-3.936-2.25l-.99-.007v5.701h2.03l.712-.792c.507-.564.83-.791 1.123-.791h.411v5.7h-.388c-.289 0-.457-.142-.653-.555-.47-.99-1.054-1.345-2.218-1.345H73.96v5.86h1.495c2.198 0 2.982-.44 3.747-2.107.45-.98.537-1.055 1.237-1.058l.539-.002-.098 2.257c-.122 2.805-.266 3.297-.957 3.257-.274-.016-1.889-.078-3.587-.138m23.357-9.344c-.078-.247.072-.514.623-1.102.963-1.03.981-1.544.081-2.367-1.757-1.605-.184-4.337 1.882-3.269 1.04.538 1.58 2.644 1.071 4.178-.628 1.888-3.281 3.746-3.657 2.56"
        clipRule="evenodd"
      />
      <path
        fill="#0A2E0B"
        fillRule="evenodd"
        stroke="#F9F4DF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.364}
        d="M36.74 82.735c-1.935-.636-2.757-1.96-2.765-4.454-.007-1.873.292-2.732 1.258-3.623 1.17-1.078 3.087-1.4 4.794-.802l.515.18v1.33c0 1.512-.28 1.814-.623.67-.611-2.04-2.656-2.062-3.43-.036-.3.785-.38 2.642-.17 3.91.183 1.096.883 1.855 1.713 1.855.84 0 1.434-.335 1.8-1.014.51-.947.71-.858.71.315v1.033l-.709.314c-.786.347-2.48.524-3.093.322m14.687-.034c-1.703-.401-1.981-1.072-2.046-4.925l-.05-2.96-.435-.454c-.24-.25-.435-.503-.435-.564s.89-.11 1.98-.11c1.088 0 1.979.063 1.979.14 0 .076-.25.33-.554.562l-.555.422.004 2.487c.002 1.367.07 2.771.15 3.12.318 1.377 1.783 1.817 2.768.831l.514-.515.115-1.17c.064-.645.067-1.964.007-2.93l-.108-1.76-.57-.593-.569-.594h1.696c.932 0 1.695.058 1.695.129 0 .07-.214.333-.475.583l-.476.456v2.702c-.001 1.487-.08 2.986-.177 3.334-.426 1.536-2.333 2.31-4.458 1.809m26.472-.036c-.92-.345-1.472-.822-1.935-1.672-.768-1.411-.824-3.996-.117-5.383.96-1.88 3.488-2.59 5.36-1.505 2.104 1.22 2.585 5.237.893 7.455-.81 1.061-2.869 1.603-4.2 1.105m2.112-1.178c.56-.593.755-1.425.756-3.217.002-2.426-.599-3.79-1.669-3.79-.413 0-1.12.761-1.3 1.397-.234.84-.117 4.339.167 4.966.503 1.11 1.355 1.378 2.046.644m6.623 1.2a4 4 0 0 1-1.008-.484c-.794-.565-.898-1.074-.898-4.363v-2.984l-.476-.456c-.26-.25-.475-.513-.475-.584s.891-.128 1.98-.128 1.98.063 1.98.14c0 .076-.25.33-.555.562l-.554.422v2.69c0 2.897.127 3.526.81 4.004.54.379 1.464.33 1.968-.102.559-.481.69-1.257.7-4.113l.006-2.335-.572-.634-.573-.634h1.523c.867 0 1.523.065 1.523.152 0 .083-.179.317-.396.519l-.396.367-.068 3.02c-.074 3.316-.202 3.897-.983 4.452-.882.627-2.35.83-3.536.49m7.992.019c-.262-.087-.778-.117-1.148-.065l-.673.093v-1.593c0-1.804.234-2.11.695-.905.33.863.848 1.359 1.6 1.528 1.047.237 1.827-.252 1.819-1.137-.006-.566-.445-1-1.739-1.722-1.877-1.047-2.376-1.642-2.376-2.842 0-1.851 1.58-2.747 4.191-2.376l1.352.192v1.233c0 1.51-.29 1.798-.708.704-.355-.93-.892-1.336-1.768-1.336-.804 0-1.324.407-1.324 1.036 0 .53.495 1.005 1.743 1.667.562.299 1.32.828 1.683 1.177 1.344 1.287 1.011 3.306-.687 4.179-.496.254-2.098.355-2.66.167m-53.134-.145c0-.084.214-.311.475-.505l.476-.35v-6.974l-.507-.522-.506-.522h2.01c1.138 0 2.012.064 2.012.147 0 .081-.214.3-.476.486l-.475.338v7.106h2.155l.507-.523c.278-.287.506-.608.506-.712 0-.105.107-.19.237-.19.19 0 .238.237.238 1.187v1.188h-3.326c-2.043 0-3.326-.06-3.326-.154m15.679.08c0-.058.253-.344.562-.636l.562-.53-.025-3.26-.025-3.26-.472-.594-.473-.594 2.113-.049c3.66-.084 4.599.202 5.021 1.528l.216.678-.255.669c-.16.417-.44.778-.745.958l-.489.289.45.278c.873.541 1.21 1.056 1.276 1.943.081 1.092-.321 1.757-1.346 2.225l-.748.342-2.81.059c-1.547.032-2.812.011-2.812-.046m4.812-1.028c.794-.301 1.12-1.547.626-2.384-.333-.563-.828-.79-1.724-.79h-.705v3.326h.702c.387 0 .882-.069 1.101-.152m.127-4.597c.351-.433.374-1.391.045-1.862-.23-.328-1.096-.672-1.698-.673l-.277-.001v3.049l.821-.079c.598-.057.9-.176 1.109-.434m3.613 5.568c0-.072.178-.298.396-.503l.396-.372v-7.016l-.396-.372c-.218-.204-.396-.43-.396-.502s.855-.131 1.9-.131c1.046 0 1.9.06 1.9.132s-.213.323-.474.555l-.475.424v2.714l.99-.082a30 30 0 0 1 1.605-.092l.616-.009-.11-1.227c-.096-1.065-.172-1.291-.576-1.71-.257-.266-.467-.533-.467-.594s.891-.111 1.98-.111 1.98.058 1.98.129c0 .07-.214.333-.475.583l-.475.456v6.849l.475.351c.261.194.475.42.475.505 0 .091-.806.154-1.98.154-1.11 0-1.98-.065-1.98-.147 0-.08.23-.326.51-.545l.508-.398.064-1.593.064-1.593h-3.204v3.119l.331.3c.183.164.399.424.48.578l.15.279h-1.906c-1.048 0-1.906-.059-1.906-.13m33.733.002c0-.07.214-.333.475-.584l.475-.455v-6.74l-.491-.56-.492-.56h6.368v1.268c0 1.283-.152 1.566-.489.91-.101-.196-.366-.552-.589-.791l-.407-.436h-1.999v2.851h.831c.658 0 .927-.083 1.292-.396.253-.218.503-.396.555-.396.104 0 .022 2.569-.084 2.681-.036.038-.299-.158-.585-.435-.434-.421-.642-.504-1.265-.504h-.744v3.326h2.192l.725-.83.725-.828v2.608h-3.246c-1.786 0-3.247-.058-3.247-.129"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient
          id="caseysindoorgolfclub_svg__a"
          x1={2.691}
          x2={6.306}
          y1={51.518}
          y2={74.096}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#72430C" />
          <stop offset={0.5} stopColor="#7B4A10" />
          <stop offset={1} stopColor="#643806" />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__b"
          x1={116.402}
          x2={120.017}
          y1={51.518}
          y2={74.096}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#72430C" />
          <stop offset={0.5} stopColor="#7B4A10" />
          <stop offset={1} stopColor="#643806" />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__d"
          x1={35.358}
          x2={85.118}
          y1={1.947}
          y2={101.468}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F0DD" />
          <stop offset={0.48} stopColor="#E8E2C7" />
          <stop offset={1} stopColor="#CABF99" />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__f"
          x1={60.938}
          x2={61.067}
          y1={2.794}
          y2={3.468}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__g"
          x1={66.403}
          x2={66.676}
          y1={2.569}
          y2={4.32}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__h"
          x1={71.481}
          x2={71.464}
          y1={1.943}
          y2={2.62}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__i"
          x1={51.539}
          x2={52.112}
          y1={5.78}
          y2={7.014}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__j"
          x1={58.468}
          x2={59.141}
          y1={4.093}
          y2={6.016}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__k"
          x1={64.362}
          x2={65.338}
          y1={4.964}
          y2={8.077}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__l"
          x1={71.871}
          x2={72.17}
          y1={3.647}
          y2={6.375}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__m"
          x1={77.375}
          x2={77.251}
          y1={2.926}
          y2={4.666}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__n"
          x1={44.034}
          x2={44.998}
          y1={9.815}
          y2={11.146}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__o"
          x1={49.059}
          x2={50.557}
          y1={8.391}
          y2={10.611}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__p"
          x1={56.255}
          x2={57.746}
          y1={6.659}
          y2={9.536}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__q"
          x1={70.204}
          x2={71.217}
          y1={7.137}
          y2={11.209}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__r"
          x1={77.307}
          x2={77.486}
          y1={5.974}
          y2={9.582}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__s"
          x1={82.882}
          x2={82.544}
          y1={5.243}
          y2={7.918}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__t"
          x1={86.436}
          x2={86.026}
          y1={4.967}
          y2={6.417}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__u"
          x1={37.549}
          x2={38.9}
          y1={14.891}
          y2={16.179}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__v"
          x1={41.424}
          x2={43.585}
          y1={13.707}
          y2={15.768}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__w"
          x1={47.175}
          x2={49.76}
          y1={12.171}
          y2={14.973}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__x"
          x1={54.339}
          x2={56.828}
          y1={10.424}
          y2={13.927}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__y"
          x1={62.277}
          x2={64.169}
          y1={8.671}
          y2={12.672}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__z"
          x1={68.322}
          x2={70.202}
          y1={11.879}
          y2={16.81}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__A"
          x1={76.156}
          x2={76.894}
          y1={10.475}
          y2={15.346}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__B"
          x1={83.072}
          x2={82.881}
          y1={9.425}
          y2={13.723}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__C"
          x1={88.636}
          x2={87.908}
          y1={8.728}
          y2={12.063}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__D"
          x1={92.54}
          x2={91.728}
          y1={8.382}
          y2={10.517}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__E"
          x1={94.597}
          x2={94.137}
          y1={8.381}
          y2={9.244}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__F"
          x1={31.556}
          x2={33.018}
          y1={21.096}
          y2={22.082}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__G"
          x1={34.446}
          x2={36.961}
          y1={20.146}
          y2={21.734}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__H"
          x1={39.007}
          x2={42.321}
          y1={18.858}
          y2={21.043}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__I"
          x1={45.024}
          x2={48.737}
          y1={17.265}
          y2={20.153}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__J"
          x1={52.196}
          x2={55.795}
          y1={15.454}
          y2={19.16}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__K"
          x1={60.136}
          x2={63.074}
          y1={13.59}
          y2={18.069}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__L"
          x1={74.555}
          x2={75.928}
          y1={16.127}
          y2={21.857}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__M"
          x1={82.32}
          x2={82.384}
          y1={14.867}
          y2={20.331}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__N"
          x1={89.071}
          x2={88.221}
          y1={13.94}
          y2={18.668}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__O"
          x1={94.526}
          x2={93.221}
          y1={13.3}
          y2={16.986}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__P"
          x1={98.49}
          x2={97.192}
          y1={12.939}
          y2={15.418}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__Q"
          x1={100.833}
          x2={99.97}
          y1={12.857}
          y2={14.095}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__R"
          x1={26.519}
          x2={27.673}
          y1={28.17}
          y2={28.729}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__S"
          x1={28.369}
          x2={30.767}
          y1={27.489}
          y2={28.478}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__T"
          x1={31.771}
          x2={35.26}
          y1={26.499}
          y2={27.844}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__U"
          x1={36.597}
          x2={40.914}
          y1={25.192}
          y2={26.975}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__V"
          x1={42.679}
          x2={47.459}
          y1={23.58}
          y2={26.026}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__W"
          x1={49.815}
          x2={54.564}
          y1={21.701}
          y2={25.095}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__X"
          x1={57.772}
          x2={61.863}
          y1={19.683}
          y2={24.177}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__Y"
          x1={66.192}
          x2={69.043}
          y1={17.752}
          y2={23.139}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__Z"
          x1={72.575}
          x2={74.612}
          y1={22.761}
          y2={29.031}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aa"
          x1={80.814}
          x2={81.101}
          y1={21.354}
          y2={27.66}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ab"
          x1={88.246}
          x2={87.271}
          y1={20.305}
          y2={26.065}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ac"
          x1={94.641}
          x2={92.921}
          y1={19.505}
          y2={24.385}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ad"
          x1={99.846}
          x2={97.845}
          y1={18.92}
          y2={22.727}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ae"
          x1={103.738}
          x2={101.879}
          y1={18.544}
          y2={21.187}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__af"
          x1={106.228}
          x2={104.895}
          y1={18.391}
          y2={19.874}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ag"
          x1={23.053}
          x2={23.764}
          y1={35.721}
          y2={35.957}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ah"
          x1={24.054}
          x2={26.087}
          y1={35.281}
          y2={35.784}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ai"
          x1={26.445}
          x2={29.707}
          y1={34.581}
          y2={35.206}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aj"
          x1={30.148}
          x2={34.462}
          y1={33.612}
          y2={34.344}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ak"
          x1={35.048}
          x2={40.188}
          y1={32.362}
          y2={33.344}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__al"
          x1={41.007}
          x2={46.688}
          y1={30.807}
          y2={32.346}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__am"
          x1={47.894}
          x2={53.704}
          y1={28.934}
          y2={31.475}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__an"
          x1={55.599}
          x2={60.882}
          y1={26.795}
          y2={30.762}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ao"
          x1={63.97}
          x2={67.89}
          y1={24.62}
          y2={30.041}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ap"
          x1={79.17}
          x2={79.415}
          y1={28.614}
          y2={35.502}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aq"
          x1={87.13}
          x2={85.722}
          y1={27.524}
          y2={33.923}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ar"
          x1={94.124}
          x2={91.792}
          y1={26.662}
          y2={32.236}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__as"
          x1={100.088}
          x2={97.349}
          y1={25.956}
          y2={30.551}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__at"
          x1={104.945}
          x2={102.204}
          y1={25.399}
          y2={28.931}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__au"
          x1={108.606}
          x2={106.224}
          y1={25.015}
          y2={27.454}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__av"
          x1={110.996}
          x2={109.306}
          y1={24.82}
          y2={26.211}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aw"
          x1={112.062}
          x2={111.349}
          y1={24.829}
          y2={25.3}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ax"
          x1={21.243}
          x2={22.443}
          y1={43.413}
          y2={43.569}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ay"
          x1={22.544}
          x2={25.06}
          y1={43.005}
          y2={43.136}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__az"
          x1={25.099}
          x2={28.802}
          y1={42.368}
          y2={42.346}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aA"
          x1={28.837}
          x2={33.552}
          y1={41.496}
          y2={41.318}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aB"
          x1={33.65}
          x2={39.195}
          y1={40.377}
          y2={40.185}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aC"
          x1={39.402}
          x2={45.594}
          y1={38.979}
          y2={39.082}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aD"
          x1={45.966}
          x2={52.559}
          y1={37.236}
          y2={38.161}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aE"
          x1={53.29}
          x2={59.771}
          y1={35.053}
          y2={37.573}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aF"
          x1={61.478}
          x2={66.718}
          y1={32.5}
          y2={37.275}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aG"
          x1={70.399}
          x2={73.131}
          y1={30.191}
          y2={36.711}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aH"
          x1={77.554}
          x2={77.141}
          y1={36.457}
          y2={43.702}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aI"
          x1={86.173}
          x2={83.645}
          y1={35.44}
          y2={41.972}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aJ"
          x1={93.657}
          x2={90.248}
          y1={34.565}
          y2={40.206}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aK"
          x1={100.174}
          x2={96.458}
          y1={33.762}
          y2={38.48}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aL"
          x1={105.682}
          x2={102.027}
          y1={33.065}
          y2={36.817}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aM"
          x1={110.087}
          x2={106.809}
          y1={32.51}
          y2={35.263}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aN"
          x1={113.299}
          x2={110.699}
          y1={32.122}
          y2={33.895}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aO"
          x1={115.244}
          x2={113.608}
          y1={31.924}
          y2={32.812}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aP"
          x1={20.45}
          x2={21.381}
          y1={51.467}
          y2={51.453}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aQ"
          x1={21.446}
          x2={23.723}
          y1={51.197}
          y2={50.963}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aR"
          x1={23.711}
          x2={27.186}
          y1={50.711}
          y2={50.089}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aS"
          x1={27.18}
          x2={31.666}
          y1={50.012}
          y2={48.947}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aT"
          x1={31.751}
          x2={37.065}
          y1={49.095}
          y2={47.655}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aU"
          x1={37.288}
          x2={43.289}
          y1={47.952}
          y2={46.337}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aV"
          x1={43.626}
          x2={50.221}
          y1={46.534}
          y2={45.129}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aW"
          x1={50.594}
          x2={57.683}
          y1={44.691}
          y2={44.253}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aX"
          x1={58.237}
          x2={65.217}
          y1={41.992}
          y2={44.144}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aY"
          x1={67.539}
          x2={71.473}
          y1={38.456}
          y2={44.67}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__aZ"
          x1={85.188}
          x2={80.399}
          y1={44.295}
          y2={49.756}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ba"
          x1={92.594}
          x2={87.59}
          y1={43.304}
          y2={48.117}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bb"
          x1={99.291}
          x2={94.355}
          y1={42.335}
          y2={46.507}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bc"
          x1={105.173}
          x2={100.502}
          y1={41.462}
          y2={44.92}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bd"
          x1={110.111}
          x2={105.908}
          y1={40.721}
          y2={43.393}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__be"
          x1={113.982}
          x2={110.475}
          y1={40.141}
          y2={41.997}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bf"
          x1={116.693}
          x2={114.125}
          y1={39.739}
          y2={40.822}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bg"
          x1={118.173}
          x2={116.769}
          y1={39.529}
          y2={39.971}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bh"
          x1={21.703}
          x2={23.631}
          y1={59.349}
          y2={58.86}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bi"
          x1={23.642}
          x2={26.718}
          y1={59.015}
          y2={57.943}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bj"
          x1={26.779}
          x2={30.791}
          y1={58.488}
          y2={56.737}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bk"
          x1={31.031}
          x2={35.765}
          y1={57.777}
          y2={55.347}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bl"
          x1={36.283}
          x2={41.559}
          y1={56.896}
          y2={53.87}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bm"
          x1={42.39}
          x2={48.081}
          y1={55.854}
          y2={52.384}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bn"
          x1={49.172}
          x2={55.229}
          y1={54.649}
          y2={50.975}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bo"
          x1={56.379}
          x2={62.906}
          y1={53.178}
          y2={49.807}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bp"
          x1={63.533}
          x2={70.988}
          y1={50.007}
          y2={50.313}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bq"
          x1={76.805}
          x2={73.335}
          y1={45.072}
          y2={51.646}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__br"
          x1={84.081}
          x2={76.821}
          y1={54.956}
          y2={56.012}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bs"
          x1={91.203}
          x2={84.534}
          y1={52.944}
          y2={55.357}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bt"
          x1={97.93}
          x2={91.785}
          y1={51.509}
          y2={54.163}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bu"
          x1={104.037}
          x2={98.419}
          y1={50.336}
          y2={52.793}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bv"
          x1={109.33}
          x2={104.331}
          y1={49.363}
          y2={51.389}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bw"
          x1={113.655}
          x2={109.43}
          y1={48.579}
          y2={50.05}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bx"
          x1={116.89}
          x2={113.632}
          y1={47.988}
          y2={48.881}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__by"
          x1={118.95}
          x2={116.855}
          y1={47.594}
          y2={47.988}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bz"
          x1={119.775}
          x2={119}
          y1={47.402}
          y2={47.476}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bA"
          x1={23.092}
          x2={24.312}
          y1={67.262}
          y2={66.797}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bB"
          x1={24.434}
          x2={26.785}
          y1={67.109}
          y2={65.942}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bC"
          x1={27.01}
          x2={30.258}
          y1={66.769}
          y2={64.761}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bD"
          x1={30.76}
          x2={34.642}
          y1={66.252}
          y2={63.349}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bE"
          x1={35.597}
          x2={39.857}
          y1={65.582}
          y2={61.798}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bF"
          x1={41.417}
          x2={45.799}
          y1={64.787}
          y2={60.168}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bG"
          x1={48.116}
          x2={52.324}
          y1={63.913}
          y2={58.489}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bH"
          x1={55.669}
          x2={59.179}
          y1={63.036}
          y2={56.745}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bI"
          x1={64.525}
          x2={65.622}
          y1={62.181}
          y2={54.872}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bJ"
          x1={75.917}
          x2={69.834}
          y1={59.064}
          y2={54.789}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bK"
          x1={88.792}
          x2={81.803}
          y1={63.01}
          y2={62.031}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bL"
          x1={95.838}
          x2={89.12}
          y1={60.976}
          y2={61.346}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bM"
          x1={102.209}
          x2={96.038}
          y1={59.409}
          y2={60.289}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bN"
          x1={107.803}
          x2={102.316}
          y1={58.158}
          y2={59.08}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bO"
          x1={112.468}
          x2={107.811}
          y1={57.154}
          y2={57.863}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bP"
          x1={116.072}
          x2={112.417}
          y1={56.377}
          y2={56.769}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bQ"
          x1={118.511}
          x2={116.035}
          y1={55.817}
          y2={55.919}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bR"
          x1={119.713}
          x2={118.556}
          y1={55.475}
          y2={55.427}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bS"
          x1={26.426}
          x2={27.786}
          y1={74.674}
          y2={73.844}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bT"
          x1={28.132}
          x2={30.423}
          y1={74.544}
          y2={72.798}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bU"
          x1={31.102}
          x2={34.035}
          y1={74.224}
          y2={71.463}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bV"
          x1={35.269}
          x2={38.528}
          y1={73.734}
          y2={69.934}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bW"
          x1={40.553}
          x2={43.8}
          y1={73.095}
          y2={68.29}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bX"
          x1={46.87}
          x2={49.711}
          y1={72.335}
          y2={66.588}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bY"
          x1={54.165}
          x2={56.032}
          y1={71.465}
          y2={64.872}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__bZ"
          x1={62.486}
          x2={62.392}
          y1={70.382}
          y2={63.253}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ca"
          x1={71.794}
          x2={68.394}
          y1={68.599}
          y2={62.189}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cb"
          x1={80.912}
          x2={74.643}
          y1={65.732}
          y2={62.129}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cc"
          x1={85.332}
          x2={79.435}
          y1={72.323}
          y2={68.852}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cd"
          x1={93.089}
          x2={86.776}
          y1={70.055}
          y2={68.238}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ce"
          x1={100.004}
          x2={93.949}
          y1={68.168}
          y2={67.353}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cf"
          x1={106.024}
          x2={100.578}
          y1={66.643}
          y2={66.286}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cg"
          x1={111.015}
          x2={106.417}
          y1={65.425}
          y2={65.185}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ch"
          x1={114.837}
          x2={111.297}
          y1={64.485}
          y2={64.205}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ci"
          x1={117.369}
          x2={115.069}
          y1={63.807}
          y2={63.493}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cj"
          x1={118.534}
          x2={117.594}
          y1={63.38}
          y2={63.174}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ck"
          x1={30.438}
          x2={31.339}
          y1={81.484}
          y2={80.759}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cl"
          x1={31.934}
          x2={33.697}
          y1={81.46}
          y2={79.686}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cm"
          x1={34.857}
          x2={37.143}
          y1={81.214}
          y2={78.294}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cn"
          x1={39.141}
          x2={41.565}
          y1={80.763}
          y2={76.696}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__co"
          x1={44.69}
          x2={46.831}
          y1={80.124}
          y2={74.992}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cp"
          x1={51.399}
          x2={52.767}
          y1={79.299}
          y2={73.267}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cq"
          x1={59.154}
          x2={59.133}
          y1={78.242}
          y2={71.624}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cr"
          x1={67.773}
          x2={65.68}
          y1={76.79}
          y2={70.25}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cs"
          x1={76.76}
          x2={72.37}
          y1={74.746}
          y2={69.371}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ct"
          x1={89.388}
          x2={84.128}
          y1={78.37}
          y2={75.01}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cu"
          x1={96.736}
          x2={91.346}
          y1={76.39}
          y2={74.143}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cv"
          x1={103.126}
          x2={98.128}
          y1={74.696}
          y2={73.175}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cw"
          x1={108.4}
          x2={104.155}
          y1={73.314}
          y2={72.198}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cx"
          x1={112.401}
          x2={109.18}
          y1={72.237}
          y2={71.355}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cy"
          x1={114.995}
          x2={112.995}
          y1={71.456}
          y2={70.805}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cz"
          x1={116.094}
          x2={115.411}
          y1={70.959}
          y2={70.677}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cA"
          x1={35.55}
          x2={36.02}
          y1={87.463}
          y2={86.977}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cB"
          x1={36.74}
          x2={37.985}
          y1={87.549}
          y2={85.926}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cC"
          x1={39.503}
          x2={41.162}
          y1={87.377}
          y2={84.538}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cD"
          x1={43.772}
          x2={45.419}
          y1={86.954}
          y2={82.932}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cE"
          x1={49.423}
          x2={50.602}
          y1={86.291}
          y2={81.235}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cF"
          x1={56.299}
          x2={56.524}
          y1={85.37}
          y2={79.558}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cG"
          x1={64.17}
          x2={62.97}
          y1={84.136}
          y2={78.025}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cH"
          x1={72.672}
          x2={69.764}
          y1={82.508}
          y2={76.769}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cI"
          x1={81.26}
          x2={76.844}
          y1={80.504}
          y2={75.819}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cJ"
          x1={85.217}
          x2={81.263}
          y1={85.646}
          y2={81.513}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cK"
          x1={92.955}
          x2={88.597}
          y1={83.692}
          y2={80.53}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cL"
          x1={99.725}
          x2={95.541}
          y1={81.919}
          y2={79.571}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cM"
          x1={105.255}
          x2={101.706}
          y1={80.432}
          y2={78.68}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cN"
          x1={109.32}
          x2={106.741}
          y1={79.268}
          y2={77.99}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cO"
          x1={111.754}
          x2={110.353}
          y1={78.44}
          y2={77.663}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cP"
          x1={42.09}
          x2={42.734}
          y1={92.636}
          y2={91.616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cQ"
          x1={44.256}
          x2={45.322}
          y1={92.605}
          y2={90.315}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cR"
          x1={48.18}
          x2={49.227}
          y1={92.257}
          y2={88.741}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cS"
          x1={53.705}
          x2={54.26}
          y1={91.597}
          y2={87.05}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cT"
          x1={60.59}
          x2={60.207}
          y1={90.611}
          y2={85.384}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cU"
          x1={68.481}
          x2={66.831}
          y1={89.274}
          y2={83.871}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cV"
          x1={76.885}
          x2={73.917}
          y1={87.579}
          y2={82.588}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cW"
          x1={88.584}
          x2={85.416}
          y1={89.974}
          y2={86.434}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cX"
          x1={95.548}
          x2={92.362}
          y1={88.224}
          y2={85.444}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cY"
          x1={101.21}
          x2={98.502}
          y1={86.706}
          y2={84.625}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__cZ"
          x1={105.23}
          x2={103.372}
          y1={85.513}
          y2={84.097}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__da"
          x1={107.379}
          x2={106.571}
          y1={84.687}
          y2={84.009}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__db"
          x1={49.85}
          x2={50.43}
          y1={96.691}
          y2={95.123}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dc"
          x1={53.168}
          x2={53.768}
          y1={96.457}
          y2={93.652}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dd"
          x1={58.327}
          x2={58.494}
          y1={95.839}
          y2={92.012}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__de"
          x1={64.995}
          x2={64.34}
          y1={94.838}
          y2={90.376}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__df"
          x1={72.683}
          x2={71.001}
          y1={93.464}
          y2={88.872}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dg"
          x1={80.767}
          x2={78.148}
          y1={91.79}
          y2={87.564}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dh"
          x1={84.003}
          x2={82.023}
          y1={95.055}
          y2={91.695}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__di"
          x1={91.543}
          x2={89.419}
          y1={93.261}
          y2={90.561}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dj"
          x1={97.446}
          x2={95.742}
          y1={91.684}
          y2={89.779}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dk"
          x1={101.045}
          x2={100.164}
          y1={90.52}
          y2={89.513}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dl"
          x1={57.388}
          x2={57.688}
          y1={99.53}
          y2={98.089}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dm"
          x1={61.519}
          x2={61.631}
          y1={99.146}
          y2={96.487}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dn"
          x1={67.913}
          x2={67.398}
          y1={98.213}
          y2={94.749}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__do"
          x1={75.761}
          x2={74.422}
          y1={96.794}
          y2={93.107}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dp"
          x1={86.663}
          x2={85.496}
          y1={97.227}
          y2={94.971}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dq"
          x1={92.508}
          x2={91.621}
          y1={95.701}
          y2={94.231}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dr"
          x1={66.124}
          x2={66.16}
          y1={101.035}
          y2={99.546}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__ds"
          x1={71.656}
          x2={71.291}
          y1={100.27}
          y2={97.883}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dt"
          x1={79.11}
          x2={78.197}
          y1={98.891}
          y2={96.259}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__du"
          x1={81.743}
          x2={81.326}
          y1={99.859}
          y2={98.468}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dv"
          x1={87.456}
          x2={87.216}
          y1={98.399}
          y2={97.755}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dw"
          x1={74.695}
          x2={74.556}
          y1={101.182}
          y2={100.063}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C8C58" stopOpacity={0.34} />
          <stop offset={0.56} stopColor="#C5BA94" stopOpacity={0.035} />
          <stop offset={1} stopColor="#FFFFF2" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dz"
          x1={15.045}
          x2={15.045}
          y1={67.076}
          y2={82.557}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5D4C24" stopOpacity={0.34} />
          <stop offset={0.45} stopColor="#766434" stopOpacity={0.16} />
          <stop offset={1} stopColor="#877741" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="caseysindoorgolfclub_svg__dA"
          x1={16.629}
          x2={68.44}
          y1={40.279}
          y2={99.793}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#74460D" />
          <stop offset={0.48} stopColor="#794B0F" />
          <stop offset={1} stopColor="#6D400A" />
        </linearGradient>
        <radialGradient
          id="caseysindoorgolfclub_svg__dx"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(94.03 28.862)scale(74.4977)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFFF9" stopOpacity={0.45} />
          <stop offset={0.62} stopColor="#FFFFF9" stopOpacity={0.08} />
          <stop offset={1} stopColor="#FFFFF9" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
}
